// #1398 ゲスト注文の識別子。
//
// 「確定の瞬間だけログイン」(#1246) の線を、支払いが店頭で完結する卓注文について
// 引き直すためのもの。端末が持つ 128bit 乱数で、同じ客の追加注文をまとめるために使う。
//
// **これは bearer 相当の値**。持っている端末は「その ID で作った注文」を読める /
// 会計を申請できるので、サーバ側もゲストで通す口を卓注文まわりに限定している
// (middleware/verify_token.verify_customer_or_guest)。
//
// 保存先は localStorage。logout の clearLocalStoragePreservingDeviceId で消えるのは
// 意図どおり (アカウントを離れた端末に前の客のゲスト注文を残さない)。

const KEY = 'yokoso.guestId.v1'

function generate(): string {
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
  return `guest_${hex}`
}

/** 既に持っていればそれを、無ければ発行して返す。 */
export function getOrCreateGuestId(): string {
  try {
    const existing = localStorage.getItem(KEY)
    if (existing && /^guest_[0-9a-f]{32}$/.test(existing)) return existing
    const fresh = generate()
    localStorage.setItem(KEY, fresh)
    return fresh
  } catch {
    // localStorage が使えない環境では毎回発行する (注文はできるが引き継げない)
    return generate()
  }
}

/** 発行済みのゲストIDを返す (未発行なら null — ここでは発行しない)。 */
export function getGuestId(): string | null {
  try {
    const v = localStorage.getItem(KEY)
    return v && /^guest_[0-9a-f]{32}$/.test(v) ? v : null
  } catch {
    return null
  }
}

/** ログインでアカウントに引き継いだ後に捨てる。 */
export function clearGuestId(): void {
  try {
    localStorage.removeItem(KEY)
    // #2140 「注文した」印も捨てる (次に別の用事でゲスト ID ができたとき、注文していないのに
    // 「できました」の購読を開かない)
    localStorage.removeItem(ORDERED_KEY)
  } catch {
    // ignore
  }
}

// #2140 このゲストが注文したことがあるか。ゲスト ID は注文以外 (スタンプラリー・体験の予約) でも
// 発行されるので、「できました」の通知の購読はこちらで決める (注文していない人に購読を開かない)。
const ORDERED_KEY = 'yokoso.guestOrdered.v1'

export function markGuestOrdered(): void {
  try { localStorage.setItem(ORDERED_KEY, '1') } catch { /* 使えない環境では通知を出さないだけ */ }
}

export function hasGuestOrdered(): boolean {
  try { return localStorage.getItem(ORDERED_KEY) === '1' } catch { return false }
}
